import { Chip } from '@material-ui/core';
import React, { FC, memo } from 'react';
import styled from 'styled-components';
import { viewTexts } from '../../../constants/view-texts';
import {
  IImageInfoType,
  IProjectImageInfoType
} from '../../../types/record/image-info';
import { MuiButton } from '../form-element';
import { ImageThumbnail } from './image-thumbnail';

const gridWidthPx = 340;
const gridPaddingPx = 10;

const ImageThumbnailGrid = styled.div`
  max-width: ${gridWidthPx}px;
  padding: ${gridPaddingPx}px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const ImageThumbnailWrapper = styled.div`
  width: ${gridWidthPx - 2 * gridPaddingPx}px;
  height: 250px;
`;

const ImageInfo = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  padding: 3px;
`;

const ImageName = styled.div`
  padding: 5px;
`;

const DeleteButtonWrapper = styled.div`
  padding: 5px;
`;

interface Props {
  image: IImageInfoType | IProjectImageInfoType;
  chipLabel: string;
  buttonLabel?: string;
  onImageClick: () => void;
  onDeleteClick: () => void;
}

export const ImageThumbnailGridCell: FC<Props> = memo(
  ({ image, chipLabel,buttonLabel = viewTexts.others.delete, onImageClick, onDeleteClick }: Readonly<Props>) => (
    <ImageThumbnailGrid>
      <ImageThumbnailWrapper onClick={onImageClick}>
        <ImageThumbnail image={image} />
      </ImageThumbnailWrapper>
      <ImageInfo>
        <ImageName>{image.name}</ImageName>
        {image.isAnnotated ? (
          <Chip size={'small'} label={chipLabel} />
        ) : (
          undefined
        )}
        <DeleteButtonWrapper>
          <MuiButton
            size='small'
            label={buttonLabel}
            color='default'
            onClick={onDeleteClick}
          />
        </DeleteButtonWrapper>
      </ImageInfo>
    </ImageThumbnailGrid>
  )
);

ImageThumbnailGridCell.displayName = 'ImageThumbnailGridCell';
